import React, { forwardRef, useEffect, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import NewsCard from "./NewsCard";
import { Get } from "../utils/REST";

const getSlidesToShow = (viewportWidth) => {
  if (viewportWidth <= 768) {
    return 1;
  }

  if (viewportWidth <= 1024) {
    return 2;
  }

  return 3;
};

const CaseStudies = forwardRef((props, ref) => {
  const [data, setData] = useState([]);
  const [slidesToShow, setSlidesToShow] = useState(() => getSlidesToShow(window.innerWidth));

  const sliderSettings = {
    arrows: false,
    dots: false,
    infinite: false,
    slidesToScroll: 1,
    slidesToShow,
    speed: 500,
    swipeToSlide: true,
  };

  const getData = () => {
    Get("case-studies", { populate: "*" })
      .then((res) => {
        console.log(res);
        setData(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    getData();
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setSlidesToShow(getSlidesToShow(window.innerWidth));
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return (
    <Slider ref={ref} {...sliderSettings} className="news-track">
      {data &&
        data.map((item) => (
          <div className="news-slide" key={item.id}>
            <NewsCard
              image={item.image?.url}
              title={item.title}
              content={item.descriptions?.substring(0, 50) || ""}
            />
          </div>
        ))}
    </Slider>
  );
});

export default CaseStudies;
